var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CaseState } from '@debbie/common/dist/cases';
import { TenantType } from '@debbie/common/dist/tenants';
import { AggregationType } from '@debbie/common/dist/insights/aggregations';
import { h, c } from '@debbie/cortex/dist';
import * as reportsAPI from '@debbie/cortex/dist/api/insights';
import { selectProcedures } from '@debbie/cortex/dist/procedures/selectors';
import { selectWorkflows } from '@debbie/cortex/dist/workflows/selectors';
import THEME from '../../theme';
import Button from '../Button';
import { Row, Col } from '../Grid';
import EmailLarge from '../Icons/EmailLarge';
import Select from '../Select';
import Well from '../Well';
import Aggregation from './Aggregation';
import BulkActions from './BulkActions';
import CaseFilterBadges from './CaseFilterBadges';
import filterGroups from './groups';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors';
const AdvancedFilter = (props) => {
    const _caseFilter = useSelector((s) => s.caseFilter);
    const caseFilter = Object.assign(Object.assign({}, _caseFilter), props.caseFilter);
    const procedures = useSelector(selectProcedures);
    const tenant = useSelector(selectTenant);
    const workflows = useSelector(selectWorkflows);
    const isImportsNotLoaded = useSelector((s) => h.isNotLoaded(s.allImports));
    const lang = useSelector((s) => s.lang);
    const currentLang = useSelector((s) => s.currentLang);
    const [loading, setLoading] = useState(false);
    const [exportStarted, setExportStarted] = useState(false);
    const [aggregation, setAggregation] = useState(AggregationType.CountAll);
    useEffect(() => {
        isImportsNotLoaded && c.imports.getAll();
    }, []);
    useEffect(() => {
        if (!procedures) {
            c.procedures.get();
        }
        if (!workflows) {
            c.workflows.getAll();
        }
    }, []);
    useEffect(() => {
        setExportStarted(false);
    }, [caseFilter]);
    return (React.createElement("div", null,
        React.createElement(Row, null,
            React.createElement(Col, { width: "8" }, ((tenant === null || tenant === void 0 ? void 0 : tenant.type)
                ? filterGroups[tenant.type]
                : filterGroups[TenantType.Agency]).map((GroupComponent) => {
                return (React.createElement(GroupComponent, { onChange: props.onChange, caseFilter: caseFilter }));
            })),
            React.createElement(Col, { width: "4", style: { position: 'sticky', top: `${THEME.GRID_SPACING}px` } },
                React.createElement(Well, null,
                    React.createElement(Select, { value: aggregation || '', onChange: (e) => setAggregation(e.target.value || null) },
                        React.createElement("option", { disabled: true, value: "" },
                            "- ",
                            lang.aggregations.aggregate,
                            " -"),
                        Object.values(AggregationType).map((type) => (React.createElement("option", { key: type, value: type }, lang.aggregationTypes[type])))),
                    aggregation && (React.createElement(Aggregation, { caseFilter: caseFilter, type: aggregation })),
                    React.createElement(CaseFilterBadges, { caseFilter: caseFilter })),
                exportStarted ? (React.createElement("div", null,
                    React.createElement(EmailLarge, { style: {
                            width: '8em',
                            height: '8em',
                            margin: '0 auto',
                            display: 'block',
                        } }),
                    React.createElement("h3", { style: { textAlign: 'center' } }, lang.insights.reportOrdered),
                    React.createElement("p", { style: { textAlign: 'center' } }, lang.insights.reportOrderedText))) : (React.createElement(Button, { loading: loading, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        setLoading(true);
                        try {
                            yield reportsAPI.requestCaseOverviewReport([], currentLang, CaseState.ALL, undefined, undefined, undefined, undefined, caseFilter);
                            setExportStarted(true);
                        }
                        catch (error) {
                            console.error(error);
                            alert('Error');
                        }
                        setLoading(false);
                    }), style: { margin: '20px 0' }, block: true }, lang.caseFilter.orderCaseOverview)),
                React.createElement(BulkActions, { caseFilter: caseFilter })))));
};
export default AdvancedFilter;
//# sourceMappingURL=AdvancedFilter.js.map